import AbortService from "@rmp/core/services/abortService";
import { AuthorizationController } from "@rmp/core/api/authorization/index";
import { PERMISSIONS_STORAGE_KEY } from "@rmp/core/constants/localStorage";
import * as storage from "local-storage";

export default class PermissionsResolver {
	private readonly authorizationController: AuthorizationController;

	constructor() {
		const abortService = new AbortService();
		abortService.initialize();
		this.authorizationController = new AuthorizationController(abortService);
	}

	getPermissionsFromStorage(): string[] {
		return storage.get<string[]>(PERMISSIONS_STORAGE_KEY);
	}

	async updatePermissionsStorage() {
		const permissions = await this.authorizationController.getPermissions();

		storage.set(PERMISSIONS_STORAGE_KEY, permissions);
	}

	resetPermissionsStorage() {
		storage.remove(PERMISSIONS_STORAGE_KEY);
	}

	async resolve(): Promise<string[]> {
		let permissions = this.getPermissionsFromStorage();

		if(!permissions) {
			await this.updatePermissionsStorage();
			permissions = this.getPermissionsFromStorage();
		}

		return permissions;
	}
}
